import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product, ProductCollections } from '../../../models/product';
import { ProductCover } from '../product-cover/product-cover';
import { ProductPrice } from '../product-price/product-price';

@Component({
  selector: 'app-product-list-item',
  imports: [ProductPrice, RouterModule, ProductCover],
  templateUrl: './product-list-item.html',
  styleUrl: './product-list-item.scss',
})
export class ProductListItem {
  @Input({ required: true }) data!: Product;

  get isBestSellers(): boolean {
    return (
      this.data.collections?.includes(ProductCollections.BestSellers) ?? false
    );
  }

  get isNewArrivals(): boolean {
    if (this.isBestSellers) {
      return false;
    }
    return (
      this.data.collections?.includes(ProductCollections.NewArrivals) ?? false
    );
  }
}
